/* eslint-disable no-mixed-operators */
/* eslint-disable no-empty-pattern */
/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'
import VueCookies from 'vue-cookies'
import {EXPIRED_TOKEN_TIME, GLOT_SECRET_COOKIE} from '../../config/commonConfig'

import router from '@/router'

export default {
  // JWT
  loginJWT ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload.userDetails.email, payload.userDetails.password)
        .then(response => {

          // If there's user data in response
          if (response.data.jwt && response.data.user) {
            // Set accessToken
            localStorage.setItem('accessToken', response.data.jwt)
            const tokenExpiry = new Date(Date.now() + EXPIRED_TOKEN_TIME * 24 * 60 * 60 * 1000)
            VueCookies.set(GLOT_SECRET_COOKIE, response.data.jwt, EXPIRED_TOKEN_TIME * 24 * 60 * 60, null, `.${window.location.host.split('.').splice(1, 2).join('.')}`)
            localStorage.setItem('tokenExpiry', tokenExpiry)
            localStorage.setItem('loggedIn', 'true')

            // // Update user details
            commit('UPDATE_USER_INFO', {...response.data.user}, {root: true})
            commit('UPDATE_LAST_USER', {
              name: response.data.user.email,
              photo: response.data.user.photoURL,
              type: 'local'
            }, {root: true})
            resolve(response)
          }
        })
        .catch(error => { 
          reject(error) 
        })
    })
  },
  registerUserJWT ({ commit }, payload) {

    const { displayName, email, password, confirmPassword } = payload.userDetails

    return new Promise((resolve, reject) => {

      // Check confirm password
      if (password !== confirmPassword) {
        reject({message: 'Password doesn\'t match. Please try again.'})
      }

      jwt.registerUser(displayName, email, password)
        .then(response => {
          // Redirect User
          console.log(response.data.jwt, 'response.data.jwt')

          if (response.data.user && response.data.jwt) {
            // router.push(router.currentRoute.query.to || '/')
            // Update data in localStorage
            localStorage.setItem('accessToken', response.data.jwt)
            // eslint-disable-next-line no-mixed-operators
            const tokenExpiry = new Date(Date.now() + EXPIRED_TOKEN_TIME * 24 * 60 * 60 * 1000)
            VueCookies.set(GLOT_SECRET_COOKIE, response.data.jwt, EXPIRED_TOKEN_TIME * 24 * 60 * 60, null, `.${window.location.host.split('.').splice(1, 2).join('.')}`)
            localStorage.setItem('tokenExpiry', tokenExpiry)
            localStorage.setItem('loggedIn', 'true')
            commit('UPDATE_USER_INFO', {...response.data.user}, {root: true})
            commit('UPDATE_LAST_USER', {
              name: response.data.user.email,
              photo: response.data.user.photoURL,
              type: response.data.user.provider
            }, {root: true})
            resolve({needVerify: false})
          } else if (response.data.user) {
            resolve({needVerify: true})
          } else {
            reject({message: 'Can\'t create account now, try later'})
          }
        })
        .catch(error => { 
          reject(error) 
        })
    })
  },
  forgotPassword ({}, payload) {
    return new Promise((resolve, reject) => {
      const { email} = payload.userDetails
      jwt.forgotPassword(email).then(response => { 
        console.log(response.data.ok, 'router.currentRoute.query.to')
        if (response.data.ok) {
          console.log(router.currentRoute.query.to)
          router.push(router.currentRoute.query.to || `/sentPassword?email=${encodeURIComponent(email)}`)
          resolve(response) 
        }
      })
        .catch(error => {
          reject(error) 
        })
    })
  },
  resendConfirmation ({}, payload) {
    return new Promise((resolve, reject) => {
      const { email} = payload.userDetails
      jwt.sendEmailConfirmation(email).then(response => { 
        if (response.data.sent) {
          resolve(response) 
        }
      })
        .catch(error => {
          reject(error) 
        })
    })
  },
  resetPassword ({}, payload) {
    const { code, password, passwordConfirmation} = payload.userDetails
    return new Promise((resolve, reject) => {
      jwt.resetPassword(code, password, passwordConfirmation).then(response => { 
        console.log(response.data.ok, 'router.currentRoute.query.to')
        console.log(response)
        if (response.data.user && response.data.jwt) {
          resolve(response) 
        }
      })
        .catch(error => {
          reject(error) 
        })
    })
  },
  getUserInfo ({commit}, payload) {
    const { token } = payload
    return new Promise((resolve, reject) => {
      jwt.getUserInfo(token).then(response => { 
        console.log(response.data.ok, 'router.currentRoute.query.to')
        console.log(response)
        if (response.data) {
          localStorage.setItem('accessToken', token)
          // Update user details
          commit('UPDATE_USER_INFO', {...response.data}, {root: true})

          const tokenExpiry = new Date(Date.now() + EXPIRED_TOKEN_TIME * 24 * 60 * 60 * 1000)
          VueCookies.set(GLOT_SECRET_COOKIE, token,  EXPIRED_TOKEN_TIME * 24 * 60 * 60, null, `.${window.location.host.split('.').splice(1, 2).join('.')}`)
          localStorage.setItem('tokenExpiry', tokenExpiry)
          localStorage.setItem('loggedIn', 'true')

          resolve(response) 
        } else {
          reject({message: 'Can\'t get user'})
        }
      })
        .catch(error => {
          VueCookies.remove(GLOT_SECRET_COOKIE,  null, `.${window.location.host.split('.').splice(1, 2).join('.')}`)
          localStorage.removeItem('accessToken')
          localStorage.removeItem('tokenExpiry')
          localStorage.removeItem('loggedIn')
          localStorage.removeItem('lastUser')
          localStorage.removeItem('userInfo')
          commit('UPDATE_USER_INFO', {}, {root: true})
          commit('UPDATE_LAST_USER', {
            name: '',
            photo: '',
            type: ''
          }, {root: true})
          reject(error) 
        })
    })
  },
  logOut () {
    VueCookies.remove(GLOT_SECRET_COOKIE, null, `.${window.location.host.split('.').splice(1, 2).join('.')}`)
    VueCookies.remove(GLOT_SECRET_COOKIE)
    localStorage.removeItem('userInfo')
    localStorage.removeItem('loggedIn')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('tokenExpiry')
  },
  fetchAccessToken () {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => { resolve(response) })
    })
  },
  checkUserNameValid ({commit}, payload) {
    return new Promise((resolve, reject) => {
      jwt.validate(payload)
        .then(response => {
          if (response.data.status) {
            resolve(response) 
          }
        }).catch(error => {
          reject(error) 
        })
    })
  },
  registerUserWithEmail ({commit}, payload) {
    return new Promise((resolve, reject) => {
      jwt.registerUserWithHash(payload).then(response => {
        if (response.data) {
          // router.push(router.currentRoute.query.to || '/')
          // Update data in localStorage
          localStorage.setItem('accessToken', response.data.jwt)
          // eslint-disable-next-line no-mixed-operators
          const tokenExpiry = new Date(Date.now() + EXPIRED_TOKEN_TIME * 24 * 60 * 60 * 1000)
          VueCookies.set(GLOT_SECRET_COOKIE, response.data.jwt, EXPIRED_TOKEN_TIME * 24 * 60 * 60, null, `.${window.location.host.split('.').splice(1, 2).join('.')}`)
          localStorage.setItem('tokenExpiry', tokenExpiry)
          localStorage.setItem('loggedIn', 'true')
          commit('UPDATE_USER_INFO', {...response.data.user}, {root: true})
          commit('UPDATE_LAST_USER', {
            name: response.data.user.email,
            photo: response.data.user.photoURL,
            type: response.data.user.provider
          }, {root: true})
          resolve({needVerify: false, jwt: response.data.jwt})
        }
      }).catch(error => {
        reject(error) 
      })
    })
  },
  signupWithEmail ({commit}, payload) {
    return new Promise((resolve, reject) => {
      jwt.signupWithEmail(payload).then(response => {
        if (response.data.ok) {
          localStorage.setItem('email-register', payload.email)
          
          resolve(response) 
        }
      }).catch(error => {
        reject(error) 
      })
    })
  },
  loginExt ({commit}, payload ) {
    const editorExtensionId = payload.extId 
    const token = payload.token
      if (token && editorExtensionId) {
        try {
          // eslint-disable-next-line no-undef
          chrome.runtime.sendMessage(
            editorExtensionId,
            { action: 'loginAct', params: { token } }
          )
        } catch (err) {
          console.log('loi login ext', err)
        }
      }
  }
  
}
